import React, { useEffect, useRef, useState } from "react";
import ModalContainer from "../modalContainer/modalContainer";
import Table from "../table/table";
import "./clientIdSelect.css";

import SearchInput from "../search/searchInput/searchInput";
import FaSpinner from "../faSpinner/faSpinner";
import ClientIdRow from "./clientIdRow";
import LoginLink from "../loginLink/loginLink";
import * as actions from "../../actions";
import { connect } from "react-redux";
import { parseApplications } from "../../constants/parse/application";

import SimpleButtonWrapper from "../simpleButtonWrapper/simpleButtonWrapper";
import Button from "../button/button";
import StatusMessage from "../statusMessage/statusMessage";

const tableHeaders = [
  {
    title: "Name",
  },
  {
    title: "Organization",
  },
  {
    title: "Development",
  },
  {
    title: "Status",
  },
];

function ClientIdSelect(props) {
  const {
    modalOpen,
    handleModalClose,
    applications: propsApplications, // Applications passed from parent
    applicationsFromStore, // Applications from Redux store
    onClientIdSelected,
    onSearch,
    loading,
    query,
    onAppSelectHandler,
    selectedAppForSubscribe,
    isLoggedIn,
    subscribeApiProductToApplication,
    unsubscribeFromApiProduct,
    apiProductId,
  } = props;

  // Use applications from props if available (filtered by parent), otherwise use store
  const applications = propsApplications || applicationsFromStore || [];

  console.log("ClientIdSelect - propsApplications:", propsApplications);
  console.log("ClientIdSelect - applicationsFromStore:", applicationsFromStore);
  console.log("ClientIdSelect - final applications:", applications);

  const isMounted = useRef(false);
  const clientRow = (application) => {
    return (
      <ClientIdRow
        handleModalClose={handleModalClose}
        onClientIdSelected={onClientIdSelected}
        application={application}
        loading={loading}
        onAppSelectHandler={onAppSelectHandler}
        selectedAppForSubscribe={selectedAppForSubscribe}
        subscribeApiProductToApplication={subscribeApiProductToApplication}
        unsubscribeFromApiProduct={unsubscribeFromApiProduct}
        apiProductId={apiProductId}
      />
    );
  };

  useEffect(() => {
    if (modalOpen && props.clearSubscribeErrorMessage) {
      props.clearSubscribeErrorMessage();
    }
  }, [modalOpen]);

  useEffect(() => {
    if (
      modalOpen === true &&
      loading === false &&
      isMounted.current === false
    ) {
      // Use the standard procedure to fetch all organizations and their applications
      props.fetchApplicationsByOrganization();
      isMounted.current = true;
    }
  }, [modalOpen, loading]);

  // Content is now handled differently as applications include organization information
  const loginButton = () => (
    <div className="client-select-popup-login">
      You have to
      <div className="client-select-popup-login-button">
        <LoginLink>
          <span style={{ fontWeight: 600 }}>LOGIN</span>
        </LoginLink>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      <ModalContainer
        isOpen={modalOpen}
        closeModal={handleModalClose}
        contentLabel="Subscribe Modal"
        title="Select Client"
        className="client-select-popup-modal"
        input={
          isLoggedIn && (
            <SearchInput
              query={query}
              placeholder="Search for an app"
              onChange={onSearch}
              disabled={loading}
            />
          )
        }
      >
        <div style={{ marginTop: "24px" }}>
          {loading ? (
            <FaSpinner loading={loading} />
          ) : isLoggedIn ? (
            applications.length > 0 ? (
              <React.Fragment>
                <Table
                  className="client-select-popup-table"
                  hideFooter
                  header={tableHeaders}
                  rows={applications}
                  cellsNumber={4}
                  disableAnimations={true}
                  RenderRow={clientRow}
                />

                {props.subscribeErrorMessage && (
                  <div style={{ marginTop: 16 }}>
                    <StatusMessage modifiers={[StatusMessage.ERROR]}>
                      {props.subscribeErrorMessage}
                    </StatusMessage>
                  </div>
                )}
              </React.Fragment>
            ) : (
              <div> Create an application to try out an API </div>
            )
          ) : (
            loginButton()
          )}
        </div>
      </ModalContainer>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  applicationsFromStore: parseApplications(state.application?.applicationsById),
  loading: state.application?.loading || false,
  // Set by the subscribe cycle when the Core refuses (e.g. not Owner/Developer of that organization)
  subscribeErrorMessage: state.apiProduct?.subscribeErrorMessage || null,
});

const mapDispatchToProps = (dispatch) => ({
  fetchApplicationsByOrganization: () => {
    dispatch(actions.fetchApplicationsByOrganization());
  },
  clearSubscribeErrorMessage: () => {
    dispatch(actions.clearSubscribeErrorMessage());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientIdSelect);
